import React, { CSSProperties } from 'react';
import { connect } from 'react-redux';
import { getCurrentExperimentVariant } from '../../../../../google-optimize-ab-test/selectors/googleOptimizeABTestSelector';
import { ButtonIconProps } from './components/ButtonIcon';

type FilterTypes = 'original' | 'grayscale' | 'blur';

interface ButtonIconABTestHocProps extends ButtonIconProps {
  filter: FilterTypes;
}

export default function withButtonIconABTestHoc(ButtonIcon: any) {
  class ButtonIconABTestHoc extends React.Component<ButtonIconABTestHocProps> {
    render(): React.ReactNode {
      const { filter } = this.props;
      const originalStyle: CSSProperties = {};
      const grayscaleStyle: CSSProperties = {
        filter: 'grayscale(80%)',
      };
      const blurStyle: CSSProperties = {
        filter: 'blur(10px)',
      };

      const styleMap: { [F in FilterTypes]: CSSProperties } = {
        original: originalStyle,
        grayscale: grayscaleStyle,
        blur: blurStyle,
      };

      return (
        <ButtonIcon
          style={filter ? styleMap[filter] : styleMap['original']}
          {...this.props}
        />
      );
    }
  }
  const mapStateToProps = (state: any) => {
    const currentExperimentVariant = getCurrentExperimentVariant(
      state,
      'partner-service-button-icon',
    );
    const filter: FilterTypes = currentExperimentVariant
      ? (currentExperimentVariant.value as FilterTypes)
      : 'original';

    return { filter };
  };

  const ConnectedHoc = connect(mapStateToProps)(ButtonIconABTestHoc);

  return ConnectedHoc;
}
